import type React from "react";
import type { ReactNode } from "react";
import type { AlertType } from "~/components/icons";

export interface Props {
	type: AlertType;
	title: string;
	children: ReactNode;
}

export const Modal: React.FC<Props> = ({ type, children, title }: Props) => {
	return (
		<section className="t4-modal">
			<div
				className={`t4-modal-title t4-modal-title-${type} py-8 px-6 md:py-10 md:px-10`}
			>
				<h1 className="text-xl font-semibold">{title}</h1>
			</div>
			{children}
		</section>
	);
};

export const ModalContent: React.FC<{ children: ReactNode }> = ({
	children,
}) => (
	<div className="t4-modal-message py-8 px-6 md:py-16 md:px-12">{children}</div>
);

export const ModalAction: React.FC<{ children: ReactNode }> = ({
	children,
}) => (
	<div className="t4-modal-message-actions py-10 flex justify-center gap-2 md:gap-5">
		{children}
	</div>
);
